import { defineStore } from 'pinia';
import { useMilkomedaWSCUnwrapBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCUnwrapBridge';

export const useFarmingMilkomedaWSCUnwrapBridge = defineStore(
  'farmingMilkomedaWSCUnwrapBridge',
  () => {
    const milkomedaWSCUnwrapBridge = useMilkomedaWSCUnwrapBridge();

    return {
      ...milkomedaWSCUnwrapBridge,
    };
  },
);
